// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__28jra","additionalInfo":"AgreementModal_additionalInfo__1BXZD"};